<template lang="pug">
.text-loader(
  :class="{ 'init-loading': isInit }"
)
  .text-loader__container
    span(
      v-for="(char, idx) in text"
      :key="idx"
      :style="`--i:${idx + 1}`"
    ) {{ char }}
</template>

<script>
export default {
  name: 'TextLoader',

  props: {
    text: {
      type: String,
      default: '...',
    },
    isInit: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.init-loading {
    height: 50vh;
  }
  &__container {
    position: relative;
    -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0,0,0,.2));
    font-size: 60px;
    & span {
      font-weight: 900;
      font-size: 60px;
      display: inline-block;
      color: #{$redesignPrimary};
      text-transform: uppercase;
      animation: waviy 1s infinite;
      animation-delay: calc(.1s * var(--i));
    }
  }
}
@keyframes waviy {
  0%,40%,100% {
      transform: translateY(0)
  }
  20% {
      transform: translateY(-10px)
  }
}
</style>
